import { SelectOptionType } from '@octano/global-ui';
import { SecureResponseFile } from '../../components/AzureFilesUploader/types';

export type AnnouncementBaseRelation = {
  id: number;
  name: string;
};

export type AnnouncementSelectOptionType = SelectOptionType & {
  extra?: Record<string, any>;
};

export enum AnnouncementTarget {
  Students = 'students',
  Teachers = 'teachers',
  Admins = 'admins',
}

export type Announcement = {
  id: number;
  title: string;
  description: string;
  targets: AnnouncementTarget[];
  academicLevelId: number | null;
  studyPlanId: number | null;
  schoolId: number | null;
  publishAt: string;
  validUntilAt: string;
  academicLevel?: AnnouncementBaseRelation | null;
  studyPlan?: AnnouncementBaseRelation | null;
  school?: AnnouncementBaseRelation | null;
  supplementaryFiles?: SecureResponseFile[];
};

export type AnnouncementFormData = {
  academicLevels: AnnouncementSelectOptionType[];
  schools: AnnouncementSelectOptionType[];
  studyPlans: AnnouncementSelectOptionType[];
};

export type AnnouncementFormFile = {
  id: number;
  name: string;
};

export type AnnouncementFormFields = {
  title: string;
  description: string;
  publishAt: string;
  validUntilAt: string;
  academicLevel: SelectOptionType | null;
  studyPlan: SelectOptionType | null;
  school: SelectOptionType | null;
  targets: AnnouncementTarget[];
  supplementaryFiles: AnnouncementFormFile[];
};

export type AnnouncementFormRequest = Omit<
  AnnouncementFormFields,
  'school' | 'academicLevel' | 'studyPlan' | 'supplementaryFiles'
> & {
  academicLevelId: number | null;
  studyPlanId: number | null;
  schoolId: number | null;
  supplementaryFiles: number[];
};
